import { Snowflake, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#09090B]">
      {/* Panel izquierdo (marca) */}
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-[#27272A]">
        <div className="flex items-center gap-3 text-white">
          <div className="h-9 w-9 rounded-sm bg-[#0055FF] grid place-items-center">
            <Snowflake className="h-5 w-5" strokeWidth={2} />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight">SprayOps</span>
        </div>
        <div className="max-w-md">
          <h1 className="font-heading text-4xl font-extrabold text-white leading-tight tracking-tight">
            Contenido y redes para empresas de servicios locales
          </h1>
          <p className="mt-6 text-[#A1A1AA] text-sm leading-relaxed">
            Plataforma multi-tenant para gestionar la presencia digital de contratistas.
            Territorios, equipo, cuentas sociales y publicación automatizada, todo en un lugar.
          </p>
        </div>
        <div className="flex items-center gap-2 text-[#71717A] text-xs">
          <ShieldCheck className="h-4 w-4" /> Aislamiento por tenant y credenciales cifradas
        </div>
      </div>

      {/* Panel derecho (login) */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 text-white mb-10">
            <div className="h-9 w-9 rounded-sm bg-[#0055FF] grid place-items-center">
              <Snowflake className="h-5 w-5" strokeWidth={2} />
            </div>
            <span className="font-heading font-bold text-lg">SprayOps</span>
          </div>
          <h2 className="font-heading text-2xl font-bold text-white">Iniciar sesión</h2>
          <p className="mt-2 text-sm text-[#A1A1AA]">
            Accedé con tu cuenta de Google para continuar.
          </p>
          <Button
            data-testid="google-login-button"
            onClick={handleGoogleLogin}
            className="mt-8 w-full h-11 bg-white text-[#09090B] hover:bg-[#E4E4E7] font-medium rounded-md active:scale-[0.98] transition-colors"
          >
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            Continuar con Google
          </Button>
          <p className="mt-6 text-xs text-[#71717A] leading-relaxed">
            Al continuar aceptás el uso de la plataforma según las políticas de tu organización.
          </p>
          <p className="mt-2 text-xs text-[#71717A]">
            <a href="/privacy" className="hover:text-[#A1A1AA] transition-colors" data-testid="login-privacy-link">Privacy Policy</a>
            {" · "}
            <a href="/terms" className="hover:text-[#A1A1AA] transition-colors" data-testid="login-terms-link">Terms of Service</a>
          </p>
        </div>
      </div>
    </div>
  );
}
